import React from 'react';
import PropTypes from 'prop-types';

import './DropDownItem.scss'

export function DropDownItem({
    children,
    className = '',
    disabled = false,
    onClick,
    role = 'menuitem',
    ...props
}) {
    const classes = ['dropdown-menu-item', className].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className={classes}
            onClick={onClick}
            disabled={disabled}
            role={role}
            {...props}
        >
            {children}
        </button>
    );
}

DropDownItem.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    role: PropTypes.string,
};
